@if (workspace()) {
  <app-open-search [(showAllResults)]="showAllResults" [(searchType)]="searchType" />
} @else {
<div class="right-container" [ngClass]="{ closed: isOpen() }" [class.drawer-open]="drawer.isOpen()">
  @if(isOpen()) {
  <div
    class="flex flex-column flex-center pt-4 cursor-pointer"
    (click)="togglePanelbar()"
    [matTooltip]="'OPEN_SEARCH.OPEN_ASSISTANT' | translate"
    [matTooltipPosition]="'left'"
    matTooltipClass="tooltip-no-wrap w150"
  >
    <a class="principal-icon">
      <mat-icon fontIcon="auto_fix_high" class="icon-m"></mat-icon>
    </a>
    <span class="small-text mb-3">{{ 'OPEN_SEARCH.KNOWLEDGE_ASSISTANT' | translate }}</span>
    <button mat-icon-button class="mb-3" data-fs-element="Open-Search-Sidebar-Button-Close">
      <mat-icon class="material-symbols">right_panel_open</mat-icon>
    </button>
  </div>
  <mat-divider class="mb-3"></mat-divider>
  <button
    data-fs-element="Open-Search-Sidebar-Button-New-Search"
    mat-icon-button
    (click)="togglePanelbar(new())"
    [matTooltip]="'OPEN_SEARCH.NEW_SEARCH' | translate"
    [matTooltipPosition]="'left'"
    class="mb-3 icon-bar"
  >
    <mat-icon fontIcon="send" class="icon-m"></mat-icon>
  </button>
  <button
    data-fs-element="Open-Search-Sidebar-Button-Quick-Search"
    mat-icon-button
    (click)="togglePanelbar(quick())"
    [matTooltip]="'OPEN_SEARCH.QUICK_SEARCH' | translate"
    [matTooltipPosition]="'left'"
    class="mb-3 icon-bar"
  >
    <mat-icon fontIcon="auto_awesome" class="icon-m"></mat-icon>
  </button>
  <button
    data-fs-element="Open-Search-Sidebar-Button-Recent-Search"
    mat-icon-button
    (click)="togglePanelbar(recent())"
    [matTooltip]="'OPEN_SEARCH.RECENT_SEARCH' | translate"
    [matTooltipPosition]="'left'"
    class="icon-bar"
  >
    <mat-icon fontIcon="bookmark" class="icon-m"></mat-icon>
  </button>
  } @else {
  <app-open-search [(showAllResults)]="showAllResults" [(searchType)]="searchType" />
  }
</div>
}
